export const place = { id: "escala", path: "/escala" } as const;
